import ChatDto from '@tera/shared/src/dto/ChatDto';

/**
 * Identidade estável de um chat na lista: o par (canal, destinatário), que é
 * exatamente a chave que o backend usa para resolver o chat no envio.
 *
 * A lista é reordenada a cada evento (ver `updateChatList`), então a posição no
 * array não serve para identificar a conversa aberta — usar índice já fez
 * mensagem sair para o destinatário errado durante a janela entre o reorder e a
 * correção do índice. Preferimos `canal_id` (presente em todos os itens vindos
 * de `listFe`), com fallback para `canal.id` nos objetos montados a partir de
 * eventos de socket.
 */
export const chatKey = (chat?: ChatDto | null): string | null => {
  if (!chat) return null;

  const canalId = (chat as any).canal_id ?? chat.canal?.id;
  const canalClienteId = chat.canal_cliente_id;

  if (canalId == null || canalClienteId == null) return null;

  return `${canalId}:${canalClienteId}`;
};

export const updateChatList = (
  chats: ChatDto[],
  chatIdx: number,
  updateChatFn: (chat: ChatDto) => ChatDto,
  move: boolean = true,
) => {
  const state = chats.reduce(
    (acc: any, chat: ChatDto, idx) => {
      let _chat: any = chat;

      if (idx === chatIdx) {
        _chat = updateChatFn(chat);
        acc.atendimentoIdx =
          _chat.estado === 'atendimento'
            ? acc.atendimento.length
            : acc.atendimentoIdx;
        acc.outrosIdx =
          _chat.estado !== 'atendimento' ? acc.outros.length : acc.outrosIdx;
      }

      if (_chat.estado === 'atendimento') {
        acc.atendimento.push(_chat);
      } else {
        acc.outros.push(_chat);
      }
      return acc;
    },
    { atendimento: [], outros: [], atendimentoIdx: null, outrosIdx: null },
  );

  if (move) {
    if (state.atendimentoIdx !== null) {
      const item = state.atendimento.splice(state.atendimentoIdx, 1);
      state.atendimento.unshift(item[0]);
    }

    if (state.outrosIdx !== null) {
      const item = state.outros.splice(state.outrosIdx, 1);
      state.outros.unshift(item[0]);
    }
  }

  const updatedList = [...state.atendimento, ...state.outros];

  return updatedList;
};
